import FeedbackContainer from 'containers/customerAccounts/Feedback/index'
import React from 'react'

const FeedbackPage = () => {
  return (
    <div><FeedbackContainer/></div>
  )
}

export default FeedbackPage